import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { back } from '@platform/router.actions';
import { RootState } from '@root/app.state';

@Component({
  selector: 'app-unauthorized-for-external',
  templateUrl: './unauthorized-for-external.component.html',
  styleUrl: './unauthorized-for-external.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UnauthorizedForExternalComponent implements OnInit {
  constructor(private store$: Store<RootState>) {}

  ngOnInit(): void {}

  public back(): void {
    this.store$.dispatch(back());
  }
}
